/* eslint-disable */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Acl } from 'modules/common/components/Acl';
// import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function EndorsingOfficesContent({
  handleDelete,
  handleAddModal,
  handleEdit,
  endorsingOfficesId,
  getSingleEndorsingOffices,
  endorsingOfficesInfo,
  handleAttachModal,
  handleDetachModal
}) {
  // const permissions = getJson('permissions');

  useEffect(() => {
    if (_.isEmpty(endorsingOfficesId)) return;
    getSingleEndorsingOffices(endorsingOfficesId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(endorsingOfficesId)) return;
    getSingleEndorsingOffices(endorsingOfficesId);
  }, [endorsingOfficesId]);

  const adminList = _.get(endorsingOfficesInfo, 'included.administrators') || [];

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            {/* {Acl(permissions, ['BPLS ADD ENDORSING OFFICES']) && ( */}
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
            >
              Add Endorsing Offices &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
            {/* )} */}
          </div>
        </div>
        {!_.isEmpty(endorsingOfficesInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-8">
                <h2 className="">
                  {_.get(endorsingOfficesInfo, 'attributes.name')}
                </h2>
                <span className="full-input">
                  {_.get(endorsingOfficesInfo, 'attributes.description')}
                </span>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  {/* {Acl(permissions, ['BPLS UPDATE ENDORSING OFFICES']) && ( */}
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(endorsingOfficesInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleDelete(endorsingOfficesInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                  {/* )} */}
                </div>
              </div>
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Code
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(endorsingOfficesInfo, 'attributes.code')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Endorsing Office
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(endorsingOfficesInfo, 'attributes.name')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Description
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              endorsingOfficesInfo,
                              'attributes.description'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          New
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              endorsingOfficesInfo,
                              'attributes.for_new'
                            ) ? 'Yes' : 'No'}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Renewal
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              endorsingOfficesInfo,
                              'attributes.for_renewal'
                            ) ? 'Yes' : 'No'}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Change
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              endorsingOfficesInfo,
                              'attributes.for_change'
                            ) ? 'Yes' : 'No'}
                          </b>
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="text-dark" width="250">
                          Delinquent
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              endorsingOfficesInfo,
                              'attributes.for_delinquent'
                            ) ? 'Yes' : 'No'}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Retirement
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              endorsingOfficesInfo,
                              'attributes.for_retirement'
                            ) ? 'Yes' : 'No'}
                          </b>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                  <hr />
                  <div className='d-flex align-items-center justify-content-between mt-3 mx-1'>
                    <h3>
                      Endorsing Offices
                    </h3>
                    <div>
                      <button 
                        type='button' 
                        className='btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto mr-2'
                        onClick={handleAttachModal(endorsingOfficesInfo)}
                      >
                          Attach
                      </button>
                      <button 
                        type='button' 
                        className='btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto'
                        onClick={handleDetachModal(endorsingOfficesInfo)}
                      >
                        Detach
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive mt-2">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th scope="col" className="px-1">Administrator</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!_.isEmpty(adminList) ? (
                          <React.Fragment>
                            {adminList.map(item => {
                              return (
                                <tr className="top-border" key={item.code}>
                                  <td className="font-weight-bold py-3">
                                    {_.get(item, 'attributes.first_name')}&nbsp;&nbsp;{_.get(item, 'attributes.last_name')}
                                  </td>
                                </tr>
                            )})}
                          </React.Fragment>
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

EndorsingOfficesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleDelete: PropTypes.instanceOf(Function).isRequired,
  getSingleEndorsingOffices: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficesInfo: PropTypes.instanceOf(Object).isRequired,
  endorsingOfficesId: PropTypes.string.isRequired,
  handleAttachModal: PropTypes.instanceOf(Function).isRequired,
  handleDetachModal: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  endorsingOfficesInfo:
    _.get(api, `${c.GET_SINGLE_ENDORSING_OFFICES}.item`) || {},
  endorsingOfficesId: _.get(match, 'params.endorsingOfficesId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EndorsingOfficesContent);
